export const getPageResult = (data = {}) => {
  const { per_page, total, current_page } = data;
  if (!total) {
    return `0 Result`;
  } else if (total == 1) {
    return `1 - ${total} of ${total} Result`;
  } else if (total < per_page) {
    return `1 - ${total} of ${total} Results`;
  } else {
    return `${(current_page - 1) * per_page + 1} - ${
      per_page * current_page < total ? per_page * current_page : total
    } of ${total} Results`;
  }
};
